(() => {
  function initTestimonials(root = document) {
    root.querySelectorAll('[data-sbb-testimonials]:not([data-sbb-init])').forEach((container) => {
      container.dataset.sbbInit = 'true';

      const items = Array.from(container.querySelectorAll('[data-sbb-testimonial]'));
      const dots = Array.from(container.querySelectorAll('[data-sbb-testimonial-dot]'));
      const rotateMs = Math.max(Number(container.dataset.rotateMs) || 5000, 2500);

      if (!items.length) return;

      let activeIndex = Math.max(
        items.findIndex((item) => item.classList.contains('is-active')),
        0
      );
      let timer = null;

      const activate = (index) => {
        activeIndex = index;
        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        if (items.length < 2) return;
        stop();
        timer = window.setInterval(() => {
          activate((activeIndex + 1) % items.length);
        }, rotateMs);
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          activate(index);
          start();
        });
      });

      container.addEventListener('mouseenter', stop);
      container.addEventListener('mouseleave', start);
      container.addEventListener('focusin', stop);
      container.addEventListener('focusout', (event) => {
        if (!container.contains(event.relatedTarget)) start();
      });

      container.__sbbActivate = activate;
      container.__sbbStop = stop;

      activate(activeIndex);
      start();
    });
  }

  document.addEventListener('DOMContentLoaded', () => initTestimonials());
  document.addEventListener('shopify:section:load', (event) => initTestimonials(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target.closest('[data-sbb-testimonial]');
    if (!block) return;

    const container = block.closest('[data-sbb-testimonials]');
    if (!container) return;

    const items = Array.from(container.querySelectorAll('[data-sbb-testimonial]'));
    const index = items.indexOf(block);

    if (index >= 0 && typeof container.__sbbActivate === 'function') {
      container.__sbbActivate(index);
    }

    if (typeof container.__sbbStop === 'function') {
      container.__sbbStop();
    }
  });
})();
